module.exports = __webpack_public_path__ + "static/media/400103_02.63f38dcf.png";